import { render, staticRenderFns } from "./CategoriaMesa.vue?vue&type=template&id=566bd410&scoped=true&"
import script from "./CategoriaMesa.vue?vue&type=script&lang=js&"
export * from "./CategoriaMesa.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaMesa.vue?vue&type=style&index=0&id=566bd410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566bd410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
